import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { instalacionSelector } from '../../../selectors/sessionSelector';
import ImageGallery from 'react-image-gallery';
import { CircularProgress } from '@material-ui/core';
import useVisualizadorImagenes from './useVisualizadorImagenes';
import './styles.css';

const VisualizadorImagenes = ({ item, instalacion, onImageClick }) => {

  const renderImageItem = (imageItem) => (
    <div
      className='containerImage'
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px', cursor: "pointer", }}
      onClick={() => {
        if (onImageClick) {
          onImageClick(imageItem.original)
        } else {
          console.warn("onImageClick no está definido.");
        }
      }} 
    >
      {
        imageItem.cargando &&
        <div
          className="circularProgress"
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}
        >
          <CircularProgress />
        </div>
      }
      <img
        alt=""
        src={imageItem.original}
        onLoad={() => onImageLoad(imageItem.index)}
        onError={() => onImageError(imageItem.index)}
        style={{ display: imageItem.cargando ? 'none' : 'block', height: '100%' }}
      />
    </div>
  );

  const {
    listaImagenes,
    imagenesValidas,
    onImageLoad,
    onImageError,
    onImageGallerySlide,
  } = useVisualizadorImagenes({ item, renderImageItem, instalacionLogo: instalacion.logoCard });

  return (
    <div className='visualizadorImagenes'>
      {listaImagenes && imagenesValidas ? (
        <ImageGallery
          showBullets={false}
          showFullscreenButton={false}
          showPlayButton={false}
          showThumbnails={false}
          showIndex={false}
          items={listaImagenes}
          onSlide={onImageGallerySlide}
        />
      ) : (
        <div className='imageDefault'>
          <div>
            <img alt="Producto sin foto" src={instalacion.logoCard} />
            <div>Producto sin foto</div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

const mapStateToProps = (state) => {
  return {
    instalacion: instalacionSelector(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizadorImagenes);
